module.exports = __webpack_public_path__ + "static/media/DevLab.ecd65ba0.gif";